module.exports = __webpack_public_path__ + "static/media/htmlcss.03ce6cbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/htmlcss.svg
// module id = 814
// module chunks = 0